import(/* webpackMode: "eager" */ "/home/runner/work/deckster.xyz-v2.0/deckster.xyz-v2.0/app/learn/page.tsx");
